<template>
  <btn
    type="primary"
    :native-type="type"
    :size="size"
    :disabled="disabled || loaderVisible"
    class="btn-loader"
    @click="onClick"
  >
    <slot />

    <Loader
      v-if="loaderVisible"
      custom-class="size-sm"
    />
  </btn>
</template>

<script>

import Loader from '../Loader';

export default {
  name: 'PrimaryButton',
  components: {
    Loader,
  },
  props: {
    doOnClick: {
      type: Function,
      default: null,
    },
    size: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'submit'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showLoaderOnForm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showLoader: false,
    };
  },
  computed: {
    loaderVisible() {
      return this.showLoader || this.showLoaderOnForm;
    }
  },
  methods: {
    onClick() {
      if (this.doOnClick) {
        (async () => {
          this.showLoader = true;
          try {
            const res = this.doOnClick();

            if (res instanceof Promise) {
              await res;
            }
          } finally {
            this.showLoader = false;
          }
        })();
      }

      this.$emit('click');
    },
  },
};
</script>

<style>


</style>
